import React from 'react';
import { useSelector } from 'react-redux';
import type { CloudItem } from 'reactApp/modules/storage/storage.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';

const bottomTextConfig = {
    90: 'последние 90 дней',
    60: 'последние 2 месяца',
    30: 'последний месяц',
};

export const useContent = (item?: CloudItem) => {
    const isCorpUser = useSelector(UserSelectors.isCorpUser);
    const isObsoleteProUser = useSelector(UserSelectors.isObsoleteProUser);

    const daysCount = isObsoleteProUser ? 90 : isCorpUser ? 60 : 30;
    const header = `История файла «${item?.name}»`;
    const bottomText = bottomTextConfig[daysCount];

    const description = (
        <>
            Вы можете восстановить любую из представленных ниже версий файла.
            <br />
            Доступны версии файла за {bottomText}
        </>
    );

    return { header, description };
};
